module.exports = __webpack_public_path__ + "img/NewOctagonLogo.dcbd7667.svg";